/* One consent-gated Microsoft Clarity recorder. Keep the app embed disabled. */
(() => {
  'use strict';
  if (window.BBClarity) return;
  let config;
  try { config = JSON.parse(document.getElementById('bb-analytics-config').textContent); } catch { return; }
  if (config.enabled === false || config.clarity_enabled !== true || !/^[a-z0-9]{5,30}$/.test(config.clarity_project_id || '')) return;

  const initialQuery = new URLSearchParams(location.search);
  const editor = Boolean(window.Shopify?.designMode) || window.self !== window.top;
  const preview = config.theme_role !== 'main' || initialQuery.has('preview_theme_id');
  const qa = initialQuery.get('bb_clarity_qa') === '1' && initialQuery.get('bb_analytics_debug') === '1';
  let testSession = preview || initialQuery.get('bb_clarity_qa') === '1' || initialQuery.get('bb_analytics_test') === '1' || initialQuery.get('bb_analytics_debug') === '1';
  let localeReady = false, requested = false, halted = false, reloading = false, script, state = 'waiting';
  const queryKeys = new Set(['preview_theme_id','_fd','pb','bb_analytics_debug','bb_analytics_test','bb_clarity_qa','bundle','utm_source','utm_medium','utm_campaign','utm_content','utm_term','gclid','dclid','gbraid','wbraid','fbclid','msclkid']);
  const pageTypes = new Set(['index','product','collection','list-collections','page','blog','article','policy','cart']);

  function permission() {
    try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; } catch { return false; }
  }
  function publicPage() {
    if (location.protocol !== 'https:' || !['booandbreeze.com','www.booandbreeze.com'].includes(location.hostname) || !pageTypes.has(config.page_type)) return false;
    let path;
    try { path = decodeURIComponent(location.pathname); } catch { return false; }
    if (/[%@?#\\\u0000-\u001f]/.test(path) || /\/(?:accounts?|checkouts?|orders?|authentication)(?:\/|$)/i.test(path) || /\/pages\/track-order\/?$/i.test(path)) return false;
    if (!/^\/(?:[a-z]{2}(?:-[a-z]{2,4})?\/)?(?:(?:products|collections|pages|policies)\/[a-z0-9-]{1,100}|blogs\/[a-z0-9-]{1,80}(?:\/[a-z0-9-]{1,100})?|cart)?\/?$/i.test(path)) return false;
    for (const [key,value] of new URLSearchParams(location.search)) if (!queryKeys.has(key) || /[@\u0000-\u001f]/.test(value)) return false;
    return !location.hash || /^#(?:faq|our-story|choose-your-chimes|MainContent)$/i.test(location.hash);
  }
  function markEnvironment() {
    // Only read/write our QA marker after the processing permission is granted.
    try {
      testSession ||= sessionStorage.getItem('bb-analytics-test') === '1';
      if (testSession) sessionStorage.setItem('bb-analytics-test','1');
    } catch {}
  }
  function eligible() {
    if (editor || !localeReady || !publicPage() || !permission()) return false;
    markEnvironment();
    return !testSession || qa;
  }
  function clearRecorderCookies() {
    // These are Clarity's own first-party cookies, never Shopify consent/identity cookies.
    for (const name of ['_clck','_clsk']) for (const domain of ['',location.hostname,'.'+location.hostname,'.booandbreeze.com']) {
      try { document.cookie = name+'=; Max-Age=0; path=/; SameSite=Lax; Secure'+(domain?'; domain='+domain:''); } catch {}
    }
  }
  function stop() {
    if (!requested || halted) return;
    halted = true; state = 'stopped';
    try { window.clarity?.('consentv2',{ad_Storage:'denied',analytics_Storage:'denied'}); } catch {}
    try { window.clarity?.('stop'); } catch {}
    try { script?.remove(); } catch {}
    clearRecorderCookies();
    // A new document also cancels an in-flight SDK load. Do not rely on a queued
    // stop command to prevent a late asynchronous recorder from starting.
    reloading = true;
    try { window.location.reload(); } catch { state = 'reload_failed'; }
  }
  function start() {
    if (requested || halted || !eligible()) return;
    if (typeof window.clarity !== 'undefined' || document.querySelector('script[src*="clarity.ms/"]')) { state = 'blocked_existing_tracker'; return; }
    const queue = function(...args) { (queue.q ||= []).push(args); };
    window.clarity = queue;
    queue('consentv2',{ad_Storage:'denied',analytics_Storage:'granted'});
    queue('set','bb_environment',testSession?'test':'production');
    if (testSession) queue('set','bb_test_session','1');
    queue('set','bb_release',String(config.release));
    queue('set','bb_locale',String(config.locale));
    if (qa) queue('event','bb_qa_recording');
    requested = true; state = 'requested';
    // An explicit mask survives project-setting changes. Never add an unmask rule.
    document.body?.setAttribute('data-clarity-mask','true');
    script = document.createElement('script');
    script.id = 'bb-clarity-recorder'; script.async = true;
    script.src = 'https://www.clarity.ms/tag/'+config.clarity_project_id;
    script.onload = () => { if (!eligible() || halted) stop(); else state = 'project_script_loaded'; };
    script.onerror = () => { state = 'load_failed'; };
    document.head.appendChild(script);
  }
  function update() {
    const allow = eligible();
    if (requested && !allow) stop();
    else if (allow && !halted) start();
    else if (!requested) state = editor?'excluded_editor':!localeReady?'waiting_locale':!publicPage()?'excluded_page':!permission()?'no_permission':'excluded_test';
  }
  window.BBClarity = {status:()=>({state,environment:testSession?'test':'production',requested,reloading})};
  document.addEventListener('visitorConsentCollected',update);
  window.addEventListener('popstate',update);
  window.addEventListener('hashchange',update);
  window.addEventListener('pageshow',update);
  let retries = 0;
  const ready = setInterval(() => { update(); if (++retries >= 40) clearInterval(ready); },250);
  try { window.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.2'}],error=>{if(!error)update();}); } catch {}
  Promise.resolve(window.bbLocaleReady).then(result=>{localeReady=!result?.redirecting;update();}).catch(()=>{state='locale_failed';});
})();
